{
  "environments": {
    "development": {
      "env": "development",
      "backend_url": "http://farmaval-server-v2.test/",
      "api_url": "http://farmavel.test/api/",
      "legacy_backend_url": "http://farmaval-v1.test/",
      "assets": {
        "base_url": "http://farmaval-server-v2.test/"
      }
    },
    "staging": {
      "env": "staging",
      "backend_url": "https://farmaval-server-v2-staging.on-forge.com/",
      "api_url": "https://farmavel.on-forge.com/api/",
      "legacy_backend_url": "https://farmaval-server-v1-staging.on-forge.com/",
      "assets": {
        "base_url": "https://farmaval-server-v2-staging.on-forge.com/"
      }
    },
    "production": {
      "backend_url": "https://backend-v2.farmaval.net/",
      "api_url": "https://farmaval.farmaval.net/api/",
      "legacy_backend_url": "https://backend-v1.farmaval.net/",
      "assets": {
        "base_url": "https://backend-v2.farmaval.net/"
      }
    }
  },
  "migrated_functions": {
    "login": {
      "url": "login",
      "method": "POST"
    }
  }
}
